// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__chwRm","spin":"Spinner_spin__VJ5H1","path":"Spinner_path__5i6bW","dash":"Spinner_dash__veq-M","centerWrap":"Spinner_centerWrap__YOKpo"};